import React from 'react';

const VARIANTS = {
  true: 'badge-success', false: 'badge-danger',
  ACTIVE: 'badge-success', INACTIVE: 'badge-muted', DOWN: 'badge-danger',
  EXPIRED: 'badge-muted', CANCELLED: 'badge-muted', REVOKED: 'badge-muted',
  PENDING: 'badge-warning', APPROVED: 'badge-success', REJECTED: 'badge-danger',
};

export default function StatusBadge({ value, labels }) {
  const key = typeof value === 'boolean' ? String(value) : value;
  const className = VARIANTS[key] || 'badge-muted';
  const text = labels?.[key] || (typeof value === 'boolean' ? (value ? 'Active' : 'Inactive') : value);
  return <span className={`badge ${className}`}>{text}</span>;
}
